export const RETAIL_PLAYER_PATH_SUBSTR = '/music/player';
export const RETAIL_PLAYER_PATH_SUBSTR_REGEX_EXP = /^\/*.*\/music\/player\/?/;
export const RETAIL_PLAYER_DP_ASIN_REGEX_PATH = /\/dp\/([A-Z0-9]{10})/;
